export const gladysMendozaLabel = "Gladys Mendoza Díaz";
export const communityManagerLabel = "Community Manager";

export const LEFT = "left";
export const RIGHT = "right";
export const DISABLE = "disable";
export const ACTIVE = "active";

export const whatsAppLink = "https://wa.me/573002288092";

export const ROUTES = {
  HOME: "#home",
  SERVICES: "#services",
  WORKS: "#works",
  BRANDS: "#brands",
  CONTACTME: "#contactme",
  LETSTALK: whatsAppLink,
};

export const TABS = {
  HOME: "Inicio",
  SERVICES: "Servicios",
  WORKS: "Trabajos",
  BRANDS: "Marcas",
  CONTACTME: "Contáctame",
  LETSTALK: "¡Habla conmigo!",
};
